import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

const AdminRoute = ({ children }) => {
  const user = authService.getCurrentUser();
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!user?.is_admin) {
    // Avoid /dashboard → /admin/campaigns redirect loop for authenticated non-admins
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;